export default "__VITE_ASSET__Bv9wFsHl__"